import { render, staticRenderFns } from "./admin-zones.vue?vue&type=template&id=f327d64e&scoped=true&"
import script from "./admin-zones.component.ts?vue&type=script&lang=ts&"
export * from "./admin-zones.component.ts?vue&type=script&lang=ts&"
import style0 from "./admin-zones.scss?vue&type=style&index=0&id=f327d64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f327d64e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f327d64e')) {
      api.createRecord('f327d64e', component.options)
    } else {
      api.reload('f327d64e', component.options)
    }
    module.hot.accept("./admin-zones.vue?vue&type=template&id=f327d64e&scoped=true&", function () {
      api.rerender('f327d64e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-zones/admin-zones.vue"
export default component.exports